var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadius1Icon = function SvgRadius1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.25 3.75A2.25 2.25 0 0 0 4 6v6.5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V6a3.75 3.75 0 0 1 3.75-3.75h6.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgRadius1Icon;